module.exports = {
	init: function () {
		$(".block.slider .items").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			autoplay: false,
			infinite: true,
			fade: true,
			arrowsPlacement: "beforeSlides",
		});

		$(".block.listing-slider .items").slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			autoplay: false,
			infinite: true,
			fade: false,
			arrowsPlacement: "beforeSlides",
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 650,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	},
};
